import React from 'react';
import ReactDOM from 'react-dom';
import './res/styles.scss';
import './res/styles.css';
import Router from './pages/router';
import reportWebVitals from './reportWebVitals';
import { Provider } from 'react-redux';
import configureStore from './lib/store/configureStore'

// eslint-disable-next-line
import $ from 'jquery';
// eslint-disable-next-line
import Popper from 'popper.js';
import 'bootstrap/dist/js/bootstrap.bundle.min';

const store = configureStore();


ReactDOM.render(
  <React.StrictMode>
    <Provider store={store}>
      <Router />
    </Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();